export default __webpack_public_path__ + "static/media/parchment6.6102dd76.png";